import React from 'react';

/** @deprecated - prefer `design-system/Checkbox` */
const InputCheckbox: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = props => {
  return (
    <>
      <input className="option-input" type="checkbox" {...props} />

      <style jsx>{`
        .option-input {
          background: #fff;
          width: 14px;
          height: 14px;
          border-radius: 3px;
          border: 1px solid #f1f1f1;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          position: relative;
          display: inline-block;
          transition: all 150ms ease-out;
          cursor: pointer;
          appearance: none;
          outline: none;
        }
        .option-input:hover:not(:disabled) {
          background: #f9f9f9;
        }
        .option-input:disabled {
          appearance: checkbox;
          cursor: default;
        }
        .option-input:checked:not(:disabled) {
          background: var(--link-color);
          border: 1px solid var(--link-color);
          box-shadow: 0 0px 4px 0 var(--link-color);
        }
        .option-input:checked:before {
          content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MSA2MiI+ICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMjguNzQgMzguMzVjLTMuOS0zLjYtMTAuMjEtMTAuMi0xNC40Mi0xNC40LTQuMi0zLjkxLTYuOS0uNjEtMTIgNC44LTUuNzEgNS43IDAgOC43IDguMSAxNi44MWwxNC43MiAxNC43MmM1LjQgNC44IDkuOS0yLjQgMTcuMTEtOS4zMWwyOS40My0yOS43M2M5LjMxLTkuMDEgMTEuNDEtOS4wMSAzLjktMTYuMjItNi42LTYuOS02LjMtNi45LTE2LjgxIDMuOS00LjggNC41LTI4LjUzIDI4LjUzLTMwLjAzIDI5LjQ0eiIvPjwvc3ZnPg==);
          font-size: 12px;
          line-height: 12px;
          width: 10px;
          height: 10px;
          position: absolute;
          left: 1px;
          display: inline-block;
          text-align: center;
          z-index: 1;
          animation: grow 250ms ease-out 1 forwards;
        }
        .option-input:checked:after {
          content: '';
          background: var(--link-color);
          border-radius: 100px;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          animation: wave 500ms ease-out 1 forwards;
        }

        @keyframes wave {
          0% {
            opacity: 0.35;
            transform: scale(1);
          }
          100% {
            opacity: 0;
            transform: scale(2.4);
          }
        }

        @keyframes grow {
          0% {
            opacity: 0;
            transform: scale(0.5);
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default InputCheckbox;
